"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _withThemeProps = _interopRequireDefault(require("@sprinx/react-mui-components/withThemeProps"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _ProductImageGalleryNarrow = _interopRequireDefault(require("@sprinx/react-com/ProductImageGalleryNarrow"));

var _ProductDetailImageGalleryWide = _interopRequireDefault(require("./ProductDetailImageGalleryWide"));

var cmpThemeCfg = {
  name: 'SxComProductDetailImageGallery'
};
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      maxWidth: '100%',
      overflow: 'hidden'
    },
    gallery: {
      display: 'flex',
      '&$variant-horizontal': {
        flexDirection: 'column'
      },
      '&$variant-vertical': {
        flexDirection: 'row'
      }
    },
    'variant-horizontal': {},
    'variant-vertical': {}
  };
}, cmpThemeCfg);
/**
 * @component
 */

function ProductDetailImageGallery(_ref) {
  var adornments = _ref.adornments,
      pClasses = _ref.classes,
      className = _ref.className,
      mobileBreakpoint = _ref.mobileBreakpoint,
      product = _ref.product,
      ProductImageGalleryNarrowProps = _ref.ProductImageGalleryNarrowProps,
      ProductImageGalleryProps = _ref.ProductImageGalleryProps,
      renderToGridArea = _ref.renderToGridArea,
      variant = _ref.variant,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["adornments", "classes", "className", "mobileBreakpoint", "product", "ProductImageGalleryNarrowProps", "ProductImageGalleryProps", "renderToGridArea", "variant"]);
  var classes = useStyles({
    classes: pClasses
  });
  var theme = (0, _useTheme.default)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down(mobileBreakpoint));
  return /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    renderToGridArea: renderToGridArea
  }), mobile ? /*#__PURE__*/_react.default.createElement(_ProductImageGalleryNarrow.default, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.gallery, classes["variant-".concat(variant)]),
    product: product,
    adornments: adornments,
    variant: variant
  }, ProductImageGalleryNarrowProps)) : /*#__PURE__*/_react.default.createElement(_ProductDetailImageGalleryWide.default, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.gallery, classes["variant-".concat(variant)]),
    product: product,
    adornments: adornments,
    variant: variant
  }, ProductImageGalleryProps)));
}

process.env.NODE_ENV !== "production" ? ProductDetailImageGallery.propTypes = {
  adornments: _propTypes.default.shape({
    adornmentAsideLeft: _propTypes.default.node,
    adornmentAsideRight: _propTypes.default.node,
    adornmentInsideBottomLeft: _propTypes.default.node,
    adornmentInsideBottomRight: _propTypes.default.node,
    adornmentInsideTopLeft: _propTypes.default.node,
    adornmentInsideTopRight: _propTypes.default.node
  }),
  classes: _propTypes.default.shape({
    gallery: _propTypes.default.string,
    galleryItem: _propTypes.default.string,
    gridArea: _propTypes.default.string,
    image: _propTypes.default.string,
    root: _propTypes.default.string,
    'un-defined': _propTypes.default.string,
    'variant-horizontal': _propTypes.default.string,
    'variant-vertical': _propTypes.default.string
  }),
  className: _propTypes.default.string,
  mobileBreakpoint: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  product: _propTypes.default.shape({
    image: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string))]),
    media: _propTypes.default.arrayOf(_propTypes.default.shape({
      alt: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.shape({
        language: _propTypes.default.string.isRequired,
        text: _propTypes.default.string
      }))]),
      id: _propTypes.default.string,
      src: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string))]).isRequired
    })),
    name: _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string.isRequired,
      text: _propTypes.default.string
    }))
  }).isRequired,
  ProductImageGalleryNarrowProps: _propTypes.default.shape({}),
  ProductImageGalleryProps: _propTypes.default.shape({}),
  renderToGridArea: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['vertical', 'horizontal'])
} : void 0;
ProductDetailImageGallery.defaultProps = {
  adornments: undefined,
  classes: undefined,
  className: undefined,
  mobileBreakpoint: 'sm',
  ProductImageGalleryNarrowProps: undefined,
  ProductImageGalleryProps: undefined,
  renderToGridArea: 'image',
  variant: 'horizontal'
};

var _default = (0, _withThemeProps.default)(cmpThemeCfg)(ProductDetailImageGallery);

exports.default = _default;